import { render, staticRenderFns } from "./diagram-view-main.component.vue?vue&type=template&id=23ea3a10&scoped=true"
import script from "./diagram-view-main.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-main.component.vue?vue&type=style&index=0&id=23ea3a10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea3a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ea3a10')) {
      api.createRecord('23ea3a10', component.options)
    } else {
      api.reload('23ea3a10', component.options)
    }
    module.hot.accept("./diagram-view-main.component.vue?vue&type=template&id=23ea3a10&scoped=true", function () {
      api.rerender('23ea3a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/diagram-view-main/diagram-view-main.component.vue"
export default component.exports